import { QRCodeCanvas } from 'qrcode.react'
import { useDispatch } from 'react-redux'
import { Flex } from 'rebass'
import styled from 'styled-components'

import ktaxaLogo from '!url-loader!assets/images/logo-ktaxa-th-bordered.png'
import Button from 'common-components/button'
import { sendQrPaymentEvent, showSubmitPaymentDialog } from 'e-submission/apps/actions'
import { getToggles } from 'quick-quote/feature-toggles'
import PayerInfo from 'e-submission/components/Form/Payment/PayerInfo'

const Container = styled(({ show, ...props }) => <Flex {...props} />)`
  transition: all 0.3s ease-in-out;
  overflow: ${({ isQRCodeNetbank }) => (isQRCodeNetbank ? 'visible' : 'hidden')};
  height: ${({ show, isEnabledECBRSystemization }) => (show ? (isEnabledECBRSystemization ? 'auto' : '240px') : '0')};
`

const QRWrapper = styled(({ show, ...props }) => <Flex {...props} />)`
  opacity: ${({ show }) => (show ? 1 : 0)};
`

export const Component = (props) => {
  const { isQRCodeNetbank } = props
  const dispatch = useDispatch()

  const showLoading = () => {
    dispatch(showSubmitPaymentDialog())
  }
  const sendPaymentEvent = (payload) => {
    dispatch(sendQrPaymentEvent(payload))
  }
  const onClick = ({ payload }) => {
    showLoading()
    sendPaymentEvent(payload)
  }

  const show = !!props.value
  const value = props.value.toString()

  const isEnabledECBRSystemization = getToggles().ENABLE_ECBR_SYSTEMIZATION
  return (
    <Container
      column
      show={show}
      isEnabledECBRSystemization={isEnabledECBRSystemization}
      isQRCodeNetbank={isQRCodeNetbank}
    >
      <QRWrapper id="paymentQrWrapper" show={show} mt={30} justify="center">
        <QRCodeCanvas
          value={value}
          size={200}
          bgColor={'#ffffff'}
          fgColor={'#000000'}
          level={'H'}
          includeMargin={false}
          imageSettings={{
            src: `${ktaxaLogo}`,
            x: undefined,
            y: undefined,
            height: 40,
            width: 80,
            excavate: true,
          }}
        />
      </QRWrapper>

      {isEnabledECBRSystemization ? <PayerInfo /> : null}
    </Container>
  )
}
Component.displayName = 'QRPayment'

const QRPayment = Component
export default QRPayment
